module.exports = "build/assets/RingsideRegular-Bold.dd95e8bc.woff";